import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQAccordion({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#D4A5A5]/20 last:border-0" data-id="element-48">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-49">
        <span className="text-lg font-serif font-medium text-[#5C4033] group-hover:text-[#8B7355] transition-colors" data-id="element-50">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#D4A5A5] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" />
      </button>
      <AnimatePresence data-id="element-52">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-53">
            <p className="pb-6 text-[#6B5A4D] leading-relaxed" data-id="element-54">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}